import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Alert } from '../../components/ui/Alert';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { authApi } from '../../api/auth';
import { useTranslation } from 'react-i18next';
import { errorText } from '../../i18n/errors';

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');

  const request = useMutation({ mutationFn: () => authApi.forgotPassword(email) });

  const submit = (event: FormEvent) => {
    event.preventDefault();
    request.mutate();
  };

  // Ответ одинаков для существующего и несуществующего адреса — это защита
  // от перебора почты, и текст на экране должен вести себя так же.
  if (request.isSuccess) {
    return (
      <div className="flex flex-col gap-5">
        <h1 className="text-section-title font-semibold">{t('auth.checkEmail.title')}</h1>
        <p className="text-body text-content-secondary">
          {t('auth.checkEmail.body')}
        </p>
        <Link to="/login" className="text-meta text-accent hover:text-accent-hover">{t('auth.backToLogin')}</Link>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-5">
      <h1 className="text-section-title font-semibold">{t('auth.forgot.title')}</h1>
      <p className="text-body text-content-secondary">{t('auth.forgot.hint')}</p>

      {request.isError ? (
        <Alert tone="error">{errorText(request.error)}</Alert>
      ) : null}

      <Input
        label={t('auth.field.email')}
        name="email"
        type="email"
        autoComplete="email"
        required
        value={email}
        onChange={(event) => setEmail(event.target.value)}
      />

      <Button type="submit" variant="primary" disabled={request.isPending}>
        {request.isPending ? t('auth.sending') : t('auth.forgot.submit')}
      </Button>

      <Link to="/login" className="text-center text-meta text-content-secondary hover:text-content">{t('auth.backToLogin')}</Link>
    </form>
  );
}
